import api from "@/lib/api";
import { toast } from "@/lib/toast";

const ID = "backup";
const fmtGo = (n) => (n >= 1e9 ? `${(n / 1e9).toLocaleString("fr-FR", { maximumFractionDigits: 2 })} Go` : n >= 1e6 ? `${(n / 1e6).toLocaleString("fr-FR", { maximumFractionDigits: 1 })} Mo` : `${Math.round(n / 1e3)} Ko`);
const fmtDur = (s) => (s >= 3600 ? `${Math.floor(s / 3600)} h ${Math.round((s % 3600) / 60)} min` : s >= 60 ? `${Math.round(s / 60)} min` : `${s} s`);
let timer = null;

/** iter387 — pastille « opération longue » du backup : progression serveur, puis « Backup réussi · taille · durée » + « Voir », ou erreur + « Réessayer ». Reprend après navigation (resumer). */
export function trackBackup({ onDone, onRetry } = {}) {
  clearInterval(timer);
  const tick = async () => {
    try {
      const { data: p } = await api.get("/settings/backup/progress");
      if (p.running) { toast.progress(ID, { title: "Backup en cours", detail: p.step || "", pct: p.pct, resume: "backup" }); return; }
      clearInterval(timer); timer = null;
      if (p.result) toast.done(ID, { title: "Backup réussi", detail: `${fmtGo(p.result.size)} · ${fmtDur(p.result.duration_s)}`, link: { label: "Voir", onClick: () => { window.location.assign("/parametres?tab=backup"); } } });
      else if (p.error) toast.fail(ID, { title: "Backup échoué", detail: p.error, retry: onRetry });
      else toast.dismiss(ID);
      onDone?.(p);
    } catch { /* réseau : on réessaie au tick suivant */ }
  };
  toast.progress(ID, { title: "Backup en cours", detail: "Préparation", pct: 0, resume: "backup" });
  tick();
  timer = setInterval(tick, 2000);
}

toast.registerResumer("backup", () => trackBackup());
